import { Link } from "react-router";
import { PRICING_PUBLIC } from "../flags";
import { t } from "../i18n";
import { priceText } from "../price";

/** The price under the install buttons (Home, landing pages). Price public (MK_PRICING_PUBLIC=on): the 6b pill of the
 *  «Price line options» mockup - the trial first, the price second - linking to /pricing (owner 2026-10-14);
 *  not public: plain «Free» (ADR-0048). */
export function PriceNote() {
  if (!PRICING_PUBLIC) return <p className="price-note">{priceText("short")}</p>;
  return (
    <p className="price-note">
      <Link to="/pricing" className="price-pill">
        <span className="price-pill-trial">{t("price.pillTrial")}</span>
        <span>{t("price.pillRest")}</span>
        <span aria-hidden="true">→</span>
      </Link>
    </p>
  );
}
